export default __webpack_public_path__ + "bdf2b4b97f291746664d4ca6e2e2b87f.png";